/**
 * Mobile overlay menu: open/close, backdrop, Escape, nested submenus.
 */
module.exports = function initMobileNav() {
  const mobileNav = document.querySelector('.site-mobile-nav')
  const openButton = document.querySelector('.site-header__toggle')
  const closeButton = document.querySelector('.site-mobile-nav__close')

  if (!mobileNav || !openButton || !closeButton) {
    return
  }

  const setMenuOpen = (isOpen) => {
    mobileNav.hidden = !isOpen
    document.body.classList.toggle('mobile-menu-open', isOpen)
    openButton.setAttribute('aria-expanded', String(isOpen))
  }

  openButton.addEventListener('click', () => setMenuOpen(true))
  closeButton.addEventListener('click', () => setMenuOpen(false))

  mobileNav.addEventListener('click', (event) => {
    if (event.target === mobileNav) {
      setMenuOpen(false)
    }
  })

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      setMenuOpen(false)
    }
  })

  const parentLinks = mobileNav.querySelectorAll('.menu-item-has-children > a')

  parentLinks.forEach((link) => {
    const item = link.parentElement
    const subMenu = item ? item.querySelector(':scope > .sub-menu') : null

    if (!item || !subMenu) {
      return
    }

    const toggle = document.createElement('button')
    toggle.type = 'button'
    toggle.className = 'site-mobile-nav__submenu-toggle'
    toggle.setAttribute('aria-expanded', 'false')
    toggle.setAttribute('aria-label', `Toggle submenu for ${link.textContent.trim()}`)
    item.insertBefore(toggle, subMenu)

    const setExpanded = (isExpanded) => {
      item.classList.toggle('is-open', isExpanded)
      toggle.setAttribute('aria-expanded', String(isExpanded))
    }

    toggle.addEventListener('click', () => {
      setExpanded(!item.classList.contains('is-open'))
    })

    link.addEventListener('click', (event) => {
      if (window.innerWidth > 900) {
        return
      }

      if (!item.classList.contains('is-open')) {
        event.preventDefault()
        setExpanded(true)
      }
    })
  })
}
